import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { IOfferTermsDispatchProps, IOfferTermsStateProps, OfferTerms } from './index';

import { subscriptionPriceChangesPopupOpen } from '../../store/subscription_price_changes_popup';
import { getHittingMicrodataExperiment } from '../../utils/microdata_experiment';

function mapStateToProps(state: IState): IOfferTermsStateProps {
  const {
    abGroup,
    offerData: { user, agent },
    knAuctionCompanies,
    excludedUtilitiesTermsRegions,
  } = state;

  return {
    abGroup,
    realtyId: agent && agent.realtyUserId ? agent.realtyUserId : undefined,
    isAgent: Boolean(state.offerData.user && state.offerData.user.isAgent),
    isAuthenticated: user && user.isAuthenticated,
    isMicrodataExperimentEnable: getHittingMicrodataExperiment(state.experiments),
    offer: state.offerData.offer,
    subscription: state.offerData.subscription,
    knAuctionCompanies,
    excludedUtilitiesTermsRegions,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IOfferTermsDispatchProps {
  return {
    subscriptionPriceChangesPopupOpen: () => {
      dispatch(subscriptionPriceChangesPopupOpen());
    },
  };
}

// tslint:disable-next-line:no-any
export const OfferTermsContainer = connect<IOfferTermsStateProps, IOfferTermsDispatchProps, any>(
  mapStateToProps,
  mapDispatchToProps,
)(OfferTerms);
